// Types for admission-level payer/coverage capture (Insurance Claims
// Phase 4.5.1, wireframe S1) — mirrors backend/routes/ip/admission-record.js's
// `ip_admission_payers` shape (PAYER_FIELDS) exactly. Money fields come back
// as strings over JSON (NUMERIC columns), same convention as claims/types.ts.

export const PAYER_SCHEME_SELF = 'self';
/** scheme_code values that mean "a government scheme" — used to show the
 * scheme sub-picker and the §S1 zero-billing banner. */
export const GOVT_SCHEME_CODES = ['pmjay', 'cmchis', 'cghs', 'esi'] as const;

export type CoverageCategory = 'self' | 'cashless' | 'reimbursement' | 'scheme' | 'corporate';

export type IdProofType = 'aadhaar' | 'voter' | 'dl' | 'passport' | 'other';
export type PolicyType = 'individual' | 'floater' | 'group' | 'scheme';

export interface PayerScheme {
  code: string;
  label: string;
}

export interface Coverage {
  id: number;
  admission_id: number;
  scheme_code: string;
  insurer_or_tpa: string | null;
  policy_no: string | null;
  member_id: string | null;
  card_no: string | null;
  preauth_no: string | null;
  preauth_status: string | null;
  employer: string | null;
  valid_from: string | null;
  valid_to: string | null;
  is_primary: boolean;
  insurer_payer_id: number | null;
  tpa_payer_id: number | null;
  policy_type: PolicyType | null;
  proposer_name: string | null;
  relation_to_proposer: string | null;
  employee_id: string | null;
  sum_insured: string | number | null;
  balance_sum_insured: string | number | null;
  room_rent_limit_per_day: string | number | null;
  room_entitlement: string | null;
  copay_percent: string | number | null;
  deductible: string | number | null;
  other_policy_exists: boolean | null;
  other_policy_details: string | null;
  scheme_beneficiary_id: string | null;
  verification_ref: string | null;
  card_document_id: number | null;
  id_proof_type: IdProofType | null;
  id_proof_last4: string | null;
  id_proof_document_id: number | null;
  id_verified_by_user_id: number | null;
  id_verified_at: string | null;
  created_by_user_id: number | null;
  created_at: string;
}

/** The POST/PATCH response — the routes carry the resolved/created claim id
 * alongside the coverage row, so the UI can show the "Claim CLM/… created"
 * confirmation in one round trip (§S1 "On save"). */
export interface CoverageSaveResult extends Coverage {
  claim_id: number | null;
}

export type CoverageInput = Partial<Omit<Coverage, 'id' | 'admission_id' | 'created_by_user_id' | 'created_at'>> & {
  scheme_code: string;
};
